export default __webpack_public_path__ + "static/media/bg_lines.d2f06a2f.svg";